import { useCallback, useEffect, useMemo, useState } from "react";
import { deleteData, getData } from "../../helpers/api";
import TableLayout from "../../components/layouts/TableLayout";
import { INITIAL_ACTIONS } from "../../constants/others";
import AddSubordinated from "../../components/users/AddSubordinated";
import withRoleProtection from "../../components/withRoleProtection";
import { DeleteOutlined, EditOutlined, EyeOutlined, ExclamationCircleFilled } from "@ant-design/icons"
import { Modal, Space } from "antd";
import { openNotification } from "../../helpers/alerts";
const { confirm } = Modal;

const INITIAL_VALUE = {
    managerId: null,
    subordinatedId: null,
}
const Manager = () => {
    const [subordinated, setSubordinated] = useState(INITIAL_VALUE)
    const [subordinateds, setSubordinateds] = useState([])
    const [total, setTotal] = useState(0)
    const columns = useMemo(() => [
        {
            title: "manager",
            dataIndex: "manager",
            key: "manager",
        },
        {
            title: "Subordonné",
            dataIndex: "name",
            key: "name",
        },
        {
            title: "Actions",
            dataIndex: "actions",
            render: (text, record) => {
                return (
                    <Space size="middle">
                        <span>
                            <DeleteOutlined
                                onClick={() => { showDeleteConfirm(record.id) }}
                            />
                        </span>
                        <span>
                            <EditOutlined
                                onClick={() => {
                                    const subordinatedToEdit = subordinateds.find((el) => el.id === record.id);
                                    const initialValues = {
                                        id: subordinatedToEdit.id,
                                        managerId: subordinatedToEdit.manager.id,
                                        subordinatedId: subordinatedToEdit.id,
                                        subordinatedName: subordinatedToEdit.name
                                    }
                                    setSubordinated({ ...initialValues, edit: true })
                                }}
                            />
                        </span>
                    </Space>
                )
            },
        }
    ], [subordinateds])


    const showDeleteConfirm = (productId) => {
        confirm({
            title: 'Vous êtes sûr de supprimer ce produit ?',
            icon: <ExclamationCircleFilled />,
            okText: 'Suprimer',
            okType: 'danger',
            cancelText: 'Anuler',
            onOk() {
                removeManger(productId)
            },
        });
    };

    const removeManger = async (subordinatedId) => {
        try {
            await deleteData(`subordinated/${subordinatedId}`);
            openNotification(`Le manager a été suprimer avec succès`, 'success');
            getUserDetailsWithRelations();
        } catch (error) {
            openNotification(`Erreurs côté serveur`, 'error')
        }
    }
    const getUserDetailsWithRelations = useCallback(async (page = 1, limit = 10) => {
        try {
            const res = await getData('/subordinated/managers', {
                page,
                limit,
            })
            setSubordinateds(res.data.subordinateds)
            setTotal(res.data.total)
        } catch (error) {
            console.log(error)
        }
    }, [])

    useEffect(() => {
        getUserDetailsWithRelations()
    }, [])

    const handleCancel = () => {
        setSubordinated({ ...INITIAL_VALUE, ...INITIAL_ACTIONS })
    }

    const handleAfterAddingSubordinated = () => {
        getUserDetailsWithRelations()
        handleCancel()
    }

    const mapSubordinatedData = (data) => {
        return data.map((el) => ({
            id: el.id,
            name: `${el.name}/${el.role}`,
            manager: el.manager.name,
        }))
    }
    return (
        <>
            {(subordinated.add || subordinated.edit) && <AddSubordinated
                handleAfterAddingSubordinated={handleAfterAddingSubordinated}
                initialValue={subordinated}
                isModalOpen={subordinated.add || subordinated.edit}
                handleCancel={handleCancel}
            />}
            <TableLayout
                columns={columns}
                total={total}
                getData={getUserDetailsWithRelations}
                dataSource={mapSubordinatedData(subordinateds)}
                setAddElementModal={() => { setSubordinated({ ...INITIAL_VALUE, add: true }) }}
            />
        </>
    );
}

export default withRoleProtection(Manager, ['super admin']);